if (!customElements.get("video-snippet")) {
  class VideoComponent extends HTMLElement {
    constructor() {
      super();

      this.video = this.querySelector("iframe, video");
      if (this.video && !this.closest(".video-carousel")) {
        this.init();
      }

      this.timeout = null;
      this.playPromise = Promise.resolve();
    }

    init() {
      this.checkVideo();
      window.addEventListener("resize", () => {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.checkVideo();
        }, 200);
      });

      this.addEventListener("click", (e) => {
        if (e.target.closest("[data-play]")) {
          this._togglePlay();
        } else if (e.target.closest("[data-mute]")) {
          this._toggleMuted();
        }
      });
    }

    checkVideo() {
      const isMobile = window.matchMedia(
        `(max-width: ${this.dataset.break_m}px`,
      ).matches;
      const src = this.video.dataset.mediaSrc;
      const mobileSrc =
        "mediaSrcMobile" in this.video.dataset
          ? this.video.dataset.mediaSrcMobile
          : src;
      const newSrc = isMobile ? mobileSrc : src;

      // Only update src if it has changed, to avoid flickering on resize
      if (newSrc !== this.video.getAttribute("src")) {
        this.video.src = newSrc;
      }

      this.dataset.fillDirection = isMobile
        ? this.dataset.fillDirectionMobile
        : this.dataset.fillDirectionDesktop;
    }

    _togglePlay() {
      if (this.video.paused) {
        this.playPromise.finally(() => {
          this.playPromise = this.video.play();
          this._playButton.dataset.play = "playing";
        });
      } else {
        this.video.pause();
        this._playButton.dataset.play = "paused";
      }
    }

    _toggleMuted() {
      if (this.video.muted) {
        this.video.muted = false;
        this._muteButton.dataset.mute = "unmuted";
      } else {
        this.video.muted = true;
        this._muteButton.dataset.mute = "muted";
      }
    }

    get _playButton() {
      return this.querySelector("[data-play]");
    }

    get _muteButton() {
      return this.querySelector("[data-mute]");
    }
  }

  customElements.define("video-snippet", VideoComponent);
}
